<table class="cpo-selectable-table">
    <thead>
      <tr class="cpo-selectable-table__header-row" style="background-color: var(--table-header-green);">
        <th (click)="sortBy_click('invoices.customer_email')">
          Customer {{ this._sortColumn === 'invoices.customer_email' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th>
        <th (click)="sortBy_click('invoices.due_date')">
          Due Date {{ this._sortColumn === 'invoices.due_date' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th>
        <th (click)="sortBy_click('invoices.total_amt_due')">
          Total {{ this._sortColumn === 'invoices.total_amt_due' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th>
        <th (click)="sortBy_click('invoices.amt_due')">
          Amount Due {{ this._sortColumn === 'invoices.amt_due' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th>
        <!-- <th (click)="sortBy_click('invoices.status')">
          Status {{ this._sortColumn === 'invoices.status' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th> -->
        <th class="no-sort">
          Days Left
        </th>
        <th (click)="sortBy_click('invoices.remaining_payments')">
          Payments Left {{ this._sortColumn === 'invoices.remaining_payments' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
        </th>
        <th class="no-sort"></th>
        <th class="no-sort"></th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        <tr>
          <td colspan="7">
            <div class="cpo-table-loading">
              <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
            </div>
          </td>
        </tr>
      } @else {
      @for (
        item of this.dataSource.data;
        track item;
        let even = $even;
        let odd = $odd
      ) {
        @if (item.id != undefined) {
          <tr
            id="trsummary_{{ item.id }}"
            [ngClass]="{ even: even, odd: odd }"
            class="cpo-selectable-table__row"
            (click)="_selectRow_click(item.id)"
          >
            <td style="background-color: var(--green-100);">
              {{ item.customerEmail }}
            </td>
            <td>
              {{ uiHelpers.formatDateTime(item.dueDate, false) }}
            </td>
            <td>
              {{ uiHelpers.formatCurrencyToString(uiHelpers.demagnifyAmount(item.totalAmtDue, 100)) }}
            </td>
            <td>{{ uiHelpers.formatCurrencyToString(uiHelpers.demagnifyAmount(item.amtDue, 100)) }}</td>
            <!-- Status Column is hidden for now, I think the tables replace the need for it -->
            <!-- <td class="cpo-selectable-table__cell">
              <span
                class="cpo-selectable-table__status"
                [class.complete]="item.status == 'paid'"
                [class.canceled]="item.status == 'sent'"
                [class.pending]="item.status == 'draft'"
              >
              @if (item.status == 'paid') {
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" fill="var(--green-900)" />
                </svg>
              } @else if (item.status == 'sent') {
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" fill="var(--gray-900)" />
                </svg>
              } @else if (item.status == 'draft') {
                <svg width="16" height="16">
                  <circle cx="8" cy="8" r="3" fill="red" />
                </svg>
              }
                {{ item.status }}
              </span>
            </td> -->
            <td [class.past-due]="checkIfInvoicePastDue(item)">{{ uiHelpers.calculateDaysSince(today, item.dueDate) }}</td>
            <td>{{ item.remainingPayments }}</td>
            <td>
              <app-icon style="cursor: pointer;" [type]="IconType.Impersonate" [color]="'var(--green-800)'" (click)="viewInvoice(item.id)"></app-icon>
            </td>
            @if (item.status != 'paid') {
              <td>
                <app-icon style="cursor: pointer;" [type]="IconType.Trash" [color]="'var(--green-800)'" (click)="deleteInvoice(item.id)"></app-icon>
              </td>
            }
          </tr>
        }
      }
    }
    </tbody>
  </table>